import { jsx } from "@emotion/react/jsx-runtime";
import { responsiveTypographyStyles } from "./ResponsiveTypography.styles.js";
import { Typography } from "../Typography/Typography.js";
const ResponsiveTypography = ({
  mobileVariant,
  breakpoint = "md",
  ...props
}) => {
  return /* @__PURE__ */ jsx(Typography, { css: (theme) => responsiveTypographyStyles({
    theme,
    breakpoint,
    mobileVariant
  }), ...props });
};
export {
  ResponsiveTypography
};
//# sourceMappingURL=ResponsiveTypography.js.map
